import script from "./Config.vue?vue&type=script&setup=true&lang=js"
export * from "./Config.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__